export default __webpack_public_path__ + "static/pragicts-ai-it-703ad578f19f3ede9e68d6aa9b064dbd.jpg";